import React from 'react';

import AcademicOffersCreateForm from './parts/AcademicOffersCreateForm';
import AcademicOffersFormLoader from './parts/AcademicOffersFormLoader';

export default function AcademicOffersCreate() {
  return (
    <AcademicOffersFormLoader>
      {({ data, refresh }) => (
        <AcademicOffersCreateForm data={data} refresh={refresh} />
      )}
    </AcademicOffersFormLoader>
  );
}
